// ── Importer les animations GSAP
import "./animations";
// ── Carrousels (témoignages, etc.)
import { initCarousels } from "./carousel";

document.addEventListener("DOMContentLoaded", () => {
  // ─── Carrousels ──────────────────────────────────────────────────────────
  initCarousels();

  // ─── Menu burger mobile (ouverture / fermeture + animation croix) ────────
  const burgerBtn = document.getElementById("burger-btn");
  const mobileMenu = document.getElementById("mobile-menu");
  const burgerLines = burgerBtn
    ? burgerBtn.querySelectorAll("[data-burger-line]")
    : [];

  const setBurgerState = (open) => {
    burgerBtn.setAttribute("aria-expanded", String(open));
    burgerBtn.setAttribute(
      "aria-label",
      open ? "Fermer le menu" : "Ouvrir le menu",
    );
    const [top, mid, bottom] = burgerLines;
    if (open) {
      top?.classList.replace("-translate-y-2", "translate-y-0");
      top?.classList.add("rotate-45");
      mid?.classList.add("opacity-0");
      bottom?.classList.replace("translate-y-2", "translate-y-0");
      bottom?.classList.add("-rotate-45");
    } else {
      top?.classList.replace("translate-y-0", "-translate-y-2");
      top?.classList.remove("rotate-45");
      mid?.classList.remove("opacity-0");
      bottom?.classList.replace("translate-y-0", "translate-y-2");
      bottom?.classList.remove("-rotate-45");
    }
  };

  if (burgerBtn && mobileMenu) {
    burgerBtn.addEventListener("click", () => {
      const open = mobileMenu.classList.toggle("hidden") === false;
      setBurgerState(open);
    });
  }

  // ─── Fermer le menu mobile au clic sur un lien ───────────────────────────
  mobileMenu?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      mobileMenu.classList.add("hidden");
      setBurgerState(false);
    });
  });

  // ─── Accordéon des sous-menus (mobile) ───────────────────────────────────
  mobileMenu
    ?.querySelectorAll("[data-accordion-trigger]")
    .forEach((trigger) => {
      const accordion = trigger.closest("[data-accordion]");
      const panel = accordion?.querySelector("[data-accordion-panel]");
      const icon = trigger.querySelector("[data-accordion-icon]");

      trigger.addEventListener("click", () => {
        const open = panel.classList.toggle("hidden") === false;
        trigger.setAttribute("aria-expanded", String(open));
        icon?.classList.toggle("rotate-180", open);
      });
    });

  // ─── Rétraction du header flottant au défilement ─────────────────────────
  const header = document.getElementById("site-header");
  const bar = document.getElementById("header-bar");
  const logo = document.getElementById("header-logo");

  if (header && bar) {
    const setScrolled = (s) => {
      // Marge supérieure (le header se rapproche du bord)
      header.classList.toggle("mt-3", !s);
      header.classList.toggle("lg:mt-4", !s);
      header.classList.toggle("mt-1.5", s);
      header.classList.toggle("lg:mt-2", s);

      // Hauteur de la pilule
      bar.classList.toggle("h-16", !s);
      bar.classList.toggle("lg:h-[68px]", !s);
      bar.classList.toggle("h-14", s);
      bar.classList.toggle("lg:h-[58px]", s);

      // Opacité / ombre renforcées une fois défilé
      bar.classList.toggle("bg-white/80", !s);
      bar.classList.toggle("bg-white/95", s);
      bar.classList.toggle("shadow-lg", !s);
      bar.classList.toggle("shadow-xl", s);

      // Logo légèrement réduit
      logo?.classList.toggle("h-9", !s);
      logo?.classList.toggle("lg:h-11", !s);
      logo?.classList.toggle("h-8", s);
      logo?.classList.toggle("lg:h-9", s);
    };

    // État initial appliqué immédiatement (sans transition, voir app.css)
    setScrolled(window.scrollY > 24);

    // Active les transitions une fois le premier rendu peint
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        document.documentElement.classList.add("header-ready");
      }),
    );

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setScrolled(window.scrollY > 24);
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
  }
});
